import { FC } from "react";
import Script from "next/script";

interface Props {
  id: string;
}

const OutBrain: FC<Props> = ({ id }) => {


  return (
    <>
      <Script
        type="text/javascript"
        strategy="lazyOnload"
        src="https://widgets.outbrain.com/outbrain.js"
      />
      <div
        className="OUTBRAIN"
        data-ob-contenturl="DROP_PERMALINK_HERE"
        data-widget-id={id}
        data-ob-installation-key="TINDL20J008H0160OJOC02CF5"
      />
    </>
  );
};

export default OutBrain;
